<div class="modal fade" id="staticVoucherBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticVoucherBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
            </div>
            <div class="modal-body" id="error-message">
                {{ this.dialogService.message }}
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn--confirm" id="btn-continue-shopping" data-bs-dismiss="modal"
                    (click)="this.dialogService.closeDialog()">Nastavi kupovinu</button>
                <button type="button" class="btn btn--confirm btn-my-vouchers" id="btn-my-vouchers"
                    data-bs-dismiss="modal" (click)="this.navigateToMyVouchersTab()">Moji vaučeri</button>
            </div>
        </div>
    </div>
</div>